import { connect } from "react-redux";
import { withStyles } from "material-ui/styles";
import { translate } from "react-i18next";

export function wrapComponent(
    component,
    styleSheet,
    mapStateToProps,
    withTheme = false
) {
    let options = undefined;
    if (withTheme) {
        options = { withTheme };
    }
    return translate("translation")(
        withStyles(styleSheet, options)(connect(mapStateToProps)(component))
    );
}

export function withStylesAndTranslation(component, styleSheet) {
    return translate("translation")(withStyles(styleSheet)(component));
}



// WEBPACK FOOTER //
// ./src/utils/container.js